import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';

function Dcrreport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [userData, setUserData] = useState();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        if (userData) {
            fethUsers();
        }
    }, [userData]);

    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [reportDate, setreportDate] = useState(moment().format('YYYY-MM-DD'));
    const [bookingData, setbookingData] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [bookings, setbookings] = useState([]);

    const [alladults, setalladults] = useState(0)
    const [allchilds, setallchilds] = useState(0)
    const [allllserviuceamount, setallllserviuceamount] = useState(0)
    const [allllroomamount, setallllroomamount] = useState(0)
    const [allllfoodamount, setallllfoodamount] = useState(0)
    const [alllltotalamount, setalllltotalamount] = useState(0)
    const [roomscount, setroomscount] = useState(0)
    const [todasypending, settodasypending] = useState(0)
    const [pendingReceived, setpendingReceived] = useState(0)
    const [alldaytotal, setalldaytotal] = useState(0)
    const [checkoutReceived, setcheckoutReceived] = useState(0)
    const [ReceivedPayment, setReceivedPayment] = useState(0)
    const [pendinRecieved, setpendinRecieved] = useState(0)

    const fethUsers = async () => {
        try {
            if (loadincount) {
                const docRef = doc(db, "users", userData.uid)
                const docSnap = await getDoc(docRef)
                if (docSnap.exists()) {
                    setloadincount(false)
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getReport = async () => {
        if (!reportDate) {
            Toast.fire({ icon: "error", title: 'Please select From Date & To Date' });
            return;
        }
        let checkindate = reportDate;
        setloading(false);
        setbookingData([]);
        setpaymodes([]);
        
        let fromDateObj = new Date(reportDate);
        fromDateObj.setHours(0, 0, 0, 0);
        const nextDay = new Date(fromDateObj);
        nextDay.setDate(nextDay.getDate() + 1);
        
        const q1 = query(
            collection(db, 'payhistory'), 
            where('status', '==', 'Working'), 
            where('createdAt', '>=', Timestamp.fromDate(fromDateObj)),
            where('createdAt', '<', Timestamp.fromDate(nextDay))
        );
        
        const payhistorySnapshot = await getDocs(q1);
        
        const paymentHistoryData = await Promise.all(payhistorySnapshot.docs.map(async (doc1) => {
            const data = doc1.data();
            
            // FIX: Safely check if paymode ID exists before fetching to avoid the invalid segment error
            let paymode1Snap = null;
            let paymode2Snap = null;

            if (data.paymode1) {
                paymode1Snap = await getDoc(doc(db, "paymentmodes", data.paymode1));
            }
            if (data.paymode2) {
                paymode2Snap = await getDoc(doc(db, "paymentmodes", data.paymode2));
            }

            const paymode1 = paymode1Snap?.exists() ? paymode1Snap.data().paymode : "";
            const paymode2 = paymode2Snap?.exists() ? paymode2Snap.data().paymode : "";
            
            const date = data.createdAt.toDate();
            const createdat = moment(date).format('DD-MM-YYYY HH:mm:ss'); 

            return {
                id: doc1.id,
                data,
                paymode1,
                paymode2,
                amount1: data.amount1 || 0,
                amount2: data.amount2 || 0,
                utr1: data.utr1 || "",
                utr2: data.utr2 || "",
                createdat
            };
        }));

        const paymentModesTotals = {};

        const checkinDetailsCheckoutQuery = query(collection(db, 'checkindetails'), where('status', '==', 'Checkout'), where('checkindate', '==', reportDate));
        const checkinDetailsBookedQuery = query(collection(db, 'checkindetails'), where('status', '==', 'Booked'), where('checkindate', '==', reportDate));
        
        const [checkinDetailsCheckoutSnapshot, checkinDetailsBookedSnapshot] = await Promise.all([
            getDocs(checkinDetailsBookedQuery),
            getDocs(checkinDetailsCheckoutQuery),
        ]);
        
        const checkinDetailsData = [
            ...checkinDetailsCheckoutSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })),
            ...checkinDetailsBookedSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        ];

        const uniqueCheckinDetails = Array.from(
            new Map(checkinDetailsData.map(item => [item.bookingid, item])).values()
        );

        const bookingIds = uniqueCheckinDetails.map(doc => doc.bookingid);
        if (bookingIds.length === 0) {
            console.log("No bookings found for the specified report date.");
            return;
        }

        function chunkArray(array, size) {
            const chunks = [];
            for (let i = 0; i < array.length; i += size) {
                chunks.push(array.slice(i, i + size));
            }
            return chunks;
        }

        const bookingIdChunks = chunkArray(bookingIds, 30);
        const bookingSnapshots = await Promise.all(
            bookingIdChunks.map(chunk => {
                const q = query(
                    collection(db, 'bookings'),
                    where('__name__', 'in', chunk)
                );
                return getDocs(q);
            })
        );

        const allBookingDocs = bookingSnapshots.flatMap(snapshot => snapshot.docs);
        const bookingsDataMap = allBookingDocs.reduce((acc, doc) => {
            acc[doc.id] = { id: doc.id, ...doc.data() };
            return acc;
        }, {});

        const paymentHistoryMap = paymentHistoryData.reduce((acc, pay) => {
            const bookingId = pay.data.bookingid;
            if (bookingsDataMap[bookingId]) {
                if (!acc[bookingId]) {
                    acc[bookingId] = [];
                }
                acc[bookingId].push(pay);
            }
            return acc;
        }, {});

        let allllroomamount = 0;
        let allllfoodamount = 0;
        let alllltotalamount = 0;
        let allllalltoal = 0;
        let allllpaidamount = 0;
        let allllserviceamount = 0;
        let allllpending = 0;
        let noofroomscount = 0;
        let todayspending = 0;
        let pendingReceived = 0;
        let pendingReceivedZeroList = []; 
        
        const combinedData = await Promise.all(
            uniqueCheckinDetails.map(async (checkinDetail) => {
                const bookingData = bookingsDataMap[checkinDetail.bookingid] || null;
                const roomamount = bookingData?.rooamount || 0;

                const date1 = moment(bookingData.checkindate, 'YYYY-MM-DD');
                const date2 = moment(reportDate, 'YYYY-MM-DD');

                let dayDifference = date2.diff(date1, 'days');
                if (dayDifference === 0) {
                    dayDifference = 1;
                }

                let serviceamount = 0;
                if (bookingData.services && bookingData.services.length > 0) {
                    bookingData.services.forEach((item) => {
                        if (!item.createdAt) return;
                        const serviceDate = moment(item.createdAt.toDate()).format("YYYY-MM-DD");
                        if (serviceDate === reportDate) {
                            serviceamount += parseFloat(item.servicerate || 0);
                        }
                    });
                }

                let paymentHistory = paymentHistoryMap[checkinDetail.bookingid] || [];

                let paidAmount = paymentHistory.reduce(
                    (sum, pay) => sum + pay.amount1 + pay.amount2,
                    0
                );

                let totalamount = parseFloat(roomamount) + parseFloat(serviceamount);
                let alltoal = parseFloat(totalamount) * parseFloat(dayDifference);
                let remaining = parseFloat(alltoal) - parseFloat(paidAmount);

                let newrem = parseFloat(totalamount) - parseFloat(paidAmount);
                if (parseFloat(newrem) > 0) {
                    todayspending = parseFloat(todayspending) + parseFloat(newrem);
                }

                allllroomamount = parseFloat(allllroomamount) + parseFloat(roomamount.toFixed(0));
                allllfoodamount = parseFloat(allllfoodamount);
                alllltotalamount = parseFloat(alllltotalamount) + parseFloat(totalamount.toFixed(0));
                allllalltoal = parseFloat(allllalltoal) + parseFloat(alltoal.toFixed(0));
                allllpaidamount = parseFloat(allllpaidamount) + parseFloat(paidAmount.toFixed(0));
                allllserviceamount = parseFloat(allllserviceamount) + parseFloat(serviceamount.toFixed(0));
                allllpending = parseFloat(allllpending) + parseFloat(remaining.toFixed(0));
                noofroomscount = parseFloat(noofroomscount) + parseFloat(bookingData.rooms.length);

                let pendingReceived1 = 0;
                if (paidAmount > 0) {
                    pendingReceived1 = parseFloat(paidAmount) - parseFloat(totalamount);
                    pendingReceived = parseFloat(pendingReceived) + parseFloat(pendingReceived1);
                }
                
                if (parseFloat(pendingReceived1) !== 0) {
                    pendingReceivedZeroList.push({
                        bookingid: checkinDetail.bookingid,
                        customername: bookingData?.customers?.custname || 'N/A',
                        pendingReceived1: pendingReceived1,
                    });
                }

                return {
                    ...checkinDetail,
                    booking: bookingData,
                    serviceamount,
                    roomamount: roomamount.toFixed(0),
                    foodamount: 0,
                    totalamount: totalamount.toFixed(0),
                    alltoal: alltoal.toFixed(0),
                    paidamount: paidAmount.toFixed(0),
                    pending: remaining.toFixed(0),
                    todayDays: dayDifference,
                    paymentHistory,
                    pendingReceived1: pendingReceived1.toFixed(0),
                };
            })
        );
        
        setallllroomamount(allllroomamount.toFixed(0));
        setallllfoodamount(allllfoodamount.toFixed(0));
        setalllltotalamount(alllltotalamount.toFixed(0));
        setallllserviuceamount(allllserviceamount.toFixed(0));
        setroomscount(noofroomscount.toFixed(0));
        settodasypending(todayspending.toFixed(0));
        setpendingReceived(pendingReceived.toFixed(0));
        setalldaytotal((parseFloat(pendingReceived) + parseFloat(alllltotalamount)).toFixed(0));
        setbookingData(combinedData);
        setpendinRecieved(pendingReceivedZeroList)

        paymentHistoryData.forEach((payhistoryItem) => {
            const { paymode1, paymode2, amount1, amount2, data } = payhistoryItem;
            if (bookingsDataMap[data.bookingid]) {
                if (paymode1) {
                    if (!paymentModesTotals[paymode1]) paymentModesTotals[paymode1] = 0;
                    paymentModesTotals[paymode1] += amount1;
                }
                if (paymode2) {
                    if (!paymentModesTotals[paymode2]) paymentModesTotals[paymode2] = 0;
                    paymentModesTotals[paymode2] += amount2;
                }
            }
        });

        const paymentModesArray = Object.keys(paymentModesTotals).map((paymode) => ({
            paymode,
            totalAmount: paymentModesTotals[paymode]
        }));

        setpaymodes(paymentModesArray);
        
        let totalSum = 0;
        const receivedPayments = [];
        const reportDateObj = reportDate.toDate ? reportDate.toDate() : new Date(reportDate);
        const startOfDay = new Date(reportDateObj.setHours(0, 0, 0, 0));
        const endOfDay = new Date(reportDateObj.setHours(23, 59, 59, 999));
        
        const bookingsQuery1 = query(collection(db, 'bookings'), where('checkoutdate', 'in', [reportDate]), where('status', '==', 'Checkout'));
        const bookingsSnapshot1 = await getDocs(bookingsQuery1);
        
        const paymentModesSnapshot = await getDocs(collection(db, 'paymentmodes'));
        const paymentModesMap = {};
        paymentModesSnapshot.forEach((doc) => {
            paymentModesMap[doc.id] = doc.data().paymode;
        });
        
        const existingBookingIds = combinedData.map(item => item.bookingid);
        const fetchPayHistoryPromises = bookingsSnapshot1.docs.map(async (doc) => {
            const bookingId = doc.id;
            if (existingBookingIds.includes(bookingId)) return null;

            const bookingData = doc.data();
            const payHistoryQuery = query(collection(db, 'payhistory'), where('bookingid', '==', bookingId),
                where('createdAt', '>=', Timestamp.fromDate(startOfDay)),
                where('createdAt', '<=', Timestamp.fromDate(endOfDay))
            );
            
            const payHistorySnapshot = await getDocs(payHistoryQuery);
            let payHistoryTotal = 0;
            const paymentHistory = [];

            payHistorySnapshot.docs.forEach((payDoc) => {
                const payData = payDoc.data();
                payHistoryTotal += (payData.amount1 || 0) + (payData.amount2 || 0);
                const paymode1 = paymentModesMap[payData.paymode1] || "";
                const paymode2 = paymentModesMap[payData.paymode2] || "";

                paymentHistory.push({
                    amount1: payData.amount1 || 0,
                    amount2: payData.amount2 || 0,
                    paymode1: paymode1,
                    paymode2: paymode2,
                    utr1: payData.utr1 || "", 
                    utr2: payData.utr2 || "",
                    date: payData.createdAt || null 
                });
            });

            if (payHistorySnapshot.docs.length > 0) {
                totalSum += payHistoryTotal;
                receivedPayments.push({
                    bookingId,
                    ...bookingData,
                    payHistoryTotal: payHistoryTotal.toFixed(0),
                    paymentHistory 
                });
            }
        });

        await Promise.all(fetchPayHistoryPromises);
        const filteredReceivedPayments = receivedPayments.filter(item => item !== null);
        setcheckoutReceived(totalSum.toFixed(0));
        setReceivedPayment(filteredReceivedPayments);

        try {
            const q = query(collection(db, 'advancebookings'), where('checkindate', '==', checkindate), orderBy("checkindate", "asc"));
            onSnapshot(q, (querySnapshot) => {
                setbookings(querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }

        setloading(true);
    };

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    })

    const handlereportDate = (e) => {
        setreportDate(e.target.value)
        setloading(false)
    }

    const totalPersons = bookingData.reduce(
        (acc, item) => {
            acc.adults += parseInt(item.booking.adults || 0);
            acc.childs += parseInt(item.booking.childs || 0);
            return acc;
        },
        { adults: 0, childs: 0 }
    );

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| DCR Report ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className='row'>
                                            <div className='col-sm-4'>
                                                <label> Date</label>
                                                <input type='date' value={reportDate} onChange={handlereportDate} className='form-control' />
                                            </div>
                                            <div className='col-sm-3'>
                                                <br />
                                                <button className='btn btn-info' onClick={getReport}>Get Report</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    loading &&
                                    <>
                                        <div className="card  card-outline" ref={printRef}>
                                            <div className="card-body p-4">
                                                <div className="row invoice-info">
                                                    <div className="col-sm-12 invoice-col text-center">
                                                        <address>
                                                            <h4>Dasara Executive</h4>
                                                            Chatrapati Shivaji Maharaj Chouk, Tuljapur, Dist - Dharashiv, MH - 413601<br />
                                                            Phone: +91 9975294940 | Email:  dasaraexecutive@gmail.com<br />
                                                            Website:  www.dasaraexecutive.com
                                                        </address>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <table className='customers mb-3' style={{ width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <th style={{ textAlign: "center" }}>Report Date : {moment(reportDate).format('DD/MM/YYYY')}  </th>
                                                                <th style={{ textAlign: "center" }}><h5>DCR REPORT </h5></th>
                                                                <th style={{ textAlign: "center" }}>Report Time : {moment().format('DD/MM/YYYY HH:mm:ss A')}</th>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <table className="customers mb-4">
                                                        <thead>
                                                            <tr>
                                                                <th>Sr No</th>
                                                                <th>Customer Name </th>
                                                                <th>Checkin Date </th>
                                                                <th>Checkout Date </th>
                                                                <th> Days </th>
                                                                <th> Persons </th>
                                                                <th>Rooms </th>
                                                                <th style={{ textAlign: "right" }}>Amount </th>
                                                                <th style={{ textAlign: "right" }}>Extra </th>
                                                                <th style={{ textAlign: "right" }}>Total</th>
                                                                <th style={{ textAlign: "left" }}>Payments</th>
                                                                <th>Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                [...bookingData]
                                                                    .sort((a, b) => {
                                                                        const dtA = moment(`${a.checkindate} ${a.booking.checkintime}`, 'YYYY-MM-DD HH:mm');
                                                                        const dtB = moment(`${b.checkindate} ${b.booking.checkintime}`, 'YYYY-MM-DD HH:mm');
                                                                        return dtA - dtB;
                                                                    })
                                                                    .map((item, index) => {
                                                                        const totalPaid = item.paymentHistory.reduce((sum, entry) => sum + parseFloat(entry.amount1 || 0) + parseFloat(entry.amount2 || 0), 0);
                                                                        const remaining = (parseFloat(item.totalamount) - parseFloat(totalPaid)).toFixed();
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td width="80">{index + 1}</td>
                                                                                <td style={{ textTransform: "capitalize" }}>{item.booking.customers.custname}</td>
                                                                                <td>{moment(item.checkindate).format('DD/MM/YYYY')} {item.booking.checkintime}</td>
                                                                                <td>{moment(item.checkoutdate).format('DD/MM/YYYY')} {item.booking.checkouttime}</td>
                                                                                <td>1</td>
                                                                                <td> (A/{item.booking.adults}) (C/{item.booking.childs}) </td>
                                                                                <td>
                                                                                    <div className='row'>
                                                                                        {item.booking.rooms.map((item1, i) =>
                                                                                            <span key={i}>&nbsp; {item1.roomname} ({parseFloat(item1.discount)}%) </span>
                                                                                        )}
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{ textAlign: "right" }}>{item.roomamount}</td>
                                                                                <td style={{ textAlign: "right" }}>{item.serviceamount}</td>
                                                                                <td style={{ textAlign: "right" }}>{item.totalamount}</td>
                                                                                <td style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                                                                                    {
                                                                                        item.paymentHistory.length > 0 ?
                                                                                            item.paymentHistory.map((ph, idx) => (
                                                                                                <React.Fragment key={idx}>
                                                                                                    {parseFloat(ph.amount1) > 0 &&
                                                                                                        <div>
                                                                                                            <b>{ph.paymode1} : {parseFloat(ph.amount1).toFixed(0)}</b><br />
                                                                                                            {ph.utr1 && <small className="text-muted" style={{fontSize: '11px'}}>UTR: {ph.utr1}<br/></small>}
                                                                                                        </div>
                                                                                                    }
                                                                                                    {parseFloat(ph.amount2) > 0 &&
                                                                                                        <div>
                                                                                                            <b>{ph.paymode2} : {parseFloat(ph.amount2).toFixed(0)}</b><br />
                                                                                                            {ph.utr2 && <small className="text-muted" style={{fontSize: '11px'}}>UTR: {ph.utr2}<br/></small>}
                                                                                                        </div>
                                                                                                    }
                                                                                                </React.Fragment>
                                                                                            )) :
                                                                                            <b style={{ color: "red" }}>Pending <br /></b>
                                                                                    }
                                                                                    {parseFloat(item.pending) > 0 && <b style={{ color: "red" }}>Remaining : {item.pending} <br /></b>}
                                                                                </td>
                                                                                <td>
                                                                                    {item.booking.checkindate !== reportDate &&
                                                                                        <b style={{ color: "green" }}>Continued..</b>}
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                            }
                                                            <tr>
                                                                <th colSpan={4} style={{ textAlign: "right" }}>TOTAL</th>
                                                                <th>{roomscount}</th>
                                                                <th>(A/{totalPersons.adults}) (C/{totalPersons.childs})</th>
                                                                <th></th>
                                                                <th style={{ textAlign: "right" }}>{allllroomamount}</th>
                                                                <th style={{ textAlign: "right" }}>{allllserviuceamount}</th>
                                                                <th style={{ textAlign: "right" }}>{alllltotalamount}</th>
                                                                <th></th>
                                                                <th></th>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <table className='customers mb-4' style={{ width: "30%" }}>
                                                        <thead>
                                                            <tr>
                                                                <th>Paymodes</th>
                                                                <th style={{ textAlign: "right" }}>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                paymodes.map((item, index) =>
                                                                    <tr key={index}>
                                                                        <td>{item.paymode}</td>
                                                                        <td style={{ textAlign: "right" }}>{parseFloat(item.totalAmount).toFixed(0)}</td>
                                                                    </tr>
                                                                )
                                                            }
                                                            <tr>
                                                                <td>Pending Amount</td>
                                                                <td style={{ textAlign: "right" }}>{todasypending}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Total </td>
                                                                <td style={{ textAlign: "right" }}>{alllltotalamount}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Pending Received</td>
                                                                <td style={{ textAlign: "right" }}>{(parseFloat(pendingReceived)).toFixed(0)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Checkout Received</td>
                                                                <td style={{ textAlign: "right" }}>{(parseFloat(checkoutReceived)).toFixed(0)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td><b>Total Amount</b></td>
                                                                <td style={{ textAlign: "right" }}><b>{(parseFloat(alllltotalamount) + parseFloat(pendingReceived) + parseFloat(checkoutReceived)).toFixed(0)}</b></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                    <table className="customers mb-4">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan={8} style={{ backgroundColor: "#f2f2f2", textAlign: "center" }}>Checkout Received From</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Sr No</th>
                                                                <th>Customer Name </th>
                                                                <th>Checkin Date </th>
                                                                <th>Checkout Date </th>
                                                                <th> Days </th>
                                                                <th>Rooms </th>
                                                                <th style={{ textAlign: "left" }}>Payments</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                ReceivedPayment.map((item, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td width="80">{index + 1}</td>
                                                                            <td style={{ textTransform: "capitalize" }}>{item.customers.custname}</td>
                                                                            <td>{moment(item.checkindate).format('DD/MM/YYYY')} {item.checkintime}</td>
                                                                            <td>{moment(item.checkoutdate).format('DD/MM/YYYY')} {item.checkouttime}</td>
                                                                            <td> {item.noofdays}</td>
                                                                            <td>
                                                                                {item.rooms.map((item1, idx) =>
                                                                                    <span key={idx}>&nbsp; {item1.roomname}  ({parseFloat(item1.discount)}%)<br /> </span>
                                                                                )}
                                                                            </td>
                                                                            <td style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                                                                                {
                                                                                    item.paymentHistory.map((itemmm, idx) =>
                                                                                        <React.Fragment key={idx}>
                                                                                            {
                                                                                                parseFloat(itemmm.amount1) > 0 &&
                                                                                                <div>
                                                                                                    <b>{itemmm.paymode1} : {parseFloat(itemmm.amount1).toFixed(0)}</b><br />
                                                                                                    {itemmm.utr1 && <small className="text-muted" style={{fontSize: '11px'}}>UTR: {itemmm.utr1}<br/></small>}
                                                                                                </div>
                                                                                            }
                                                                                            {
                                                                                                parseFloat(itemmm.amount2) > 0 &&
                                                                                                <div>
                                                                                                    <b>{itemmm.paymode2} : {parseFloat(itemmm.amount2).toFixed(0)}</b><br/>
                                                                                                    {itemmm.utr2 && <small className="text-muted" style={{fontSize: '11px'}}>UTR: {itemmm.utr2}<br/></small>}
                                                                                                </div>
                                                                                            }
                                                                                        </React.Fragment>
                                                                                    )
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>

                                                    <table className="customers">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan={12} style={{ backgroundColor: "#f2f2f2", textAlign: "center" }}>Advance Booking</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Sr No</th>
                                                                <th>Customer Name </th>
                                                                <th>Mobile </th>
                                                                <th>Checkin Date </th>
                                                                <th>Checkout Date </th>
                                                                <th>Rooms No </th>
                                                                <th>Adults </th>
                                                                <th style={{ textAlign: "right" }}>Total</th>
                                                                <th style={{ textAlign: "right" }}>Advance</th>
                                                                <th style={{ textAlign: "left" }}>UTR Details</th>
                                                                <th style={{ textAlign: "right" }}>Remaining</th>
                                                                <th style={{ width: 120 }}>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                bookings.map((item, index) =>
                                                                    <tr key={index}>
                                                                        <td width="80">{index + 1}</td>
                                                                        <td style={{ textTransform: "capitalize" }}>{item.data.customers.custname}</td>
                                                                        <td>{item.data.customers.mobile} </td>
                                                                        <td>{moment(item.data.checkindate).format('DD/MM/YYYY')}</td>
                                                                        <td>{moment(item.data.checkoutdate).format('DD/MM/YYYY')}</td>
                                                                        <td>
                                                                            <div className='row'>
                                                                                {item.data.rooms.map((item1, i) =>
                                                                                    <span key={i}>{item1.roomname}, &nbsp;  </span>
                                                                                )}
                                                                            </div>
                                                                        </td>
                                                                        <td>{item.data.adults} Persons</td>
                                                                        <td style={{ textAlign: "right" }}>{item.data.totalamount.toFixed(2)}</td>
                                                                        <td style={{ textAlign: "right" }}>{item.data.advance.toFixed(2)}</td>
                                                                        <td style={{ textAlign: "left", whiteSpace: "nowrap" }}>
                                                                            {item.data.utr1 && <div style={{fontSize: '12px'}}>1: {item.data.utr1}</div>}
                                                                            {item.data.utr2 && <div style={{fontSize: '12px'}}>2: {item.data.utr2}</div>}
                                                                            {!item.data.utr1 && !item.data.utr2 && <span className="text-muted">-</span>}
                                                                        </td>
                                                                        <td style={{ textAlign: "right" }}>{item.data.remaining.toFixed(2)}</td>
                                                                        <td>
                                                                            <a target='_blank' rel='noreferrer' href={'view-futuredetails/' + item.id} className='btn btn-info btn-sm'><i className="fa fa-eye"></i></a>&nbsp;
                                                                            <a target='_blank' rel='noreferrer' href={'/print-advance/' + item.id} className='btn bg-pink btn-sm'><i className="fa fa-print"></i></a>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            }
                                                        </tbody>
                                                    </table>

                                                </div>
                                            </div>

                                        </div>
                                        <center className="mt-4 mb-4">
                                            <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                        </center>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </section >
            </div>
        </div >
    )
}

export default Dcrreport